export enum QuotationPartTypeEnum {
    Genuina = 1,
    Original = 2,
    Alternativa = 4,
    Importada = 8
}

const QuotationPartTypeEnumArray = [QuotationPartTypeEnum.Genuina, QuotationPartTypeEnum.Original, QuotationPartTypeEnum.Alternativa, QuotationPartTypeEnum.Importada]

export function getQuotationPartTypeEnumFromBitwise(bitwiseValue: number, partTypes: QuotationPartTypeEnum[] = QuotationPartTypeEnumArray): QuotationPartTypeEnum[] {
    return partTypes.filter(type => (bitwiseValue & type) !== 0);
}
